import { StaticFormFieldMappings } from '../../../service-request-form-response.mapper.util';
import {
  VENTI_BULK_STORAGE_CHECKLIST_KEYS,
  VENTI_EXTERNAL_VISUAL_CHECKLIST_KEYS,
  VENTI_PRV_INSTANCE_FIELD_KEYS,
  VENTI_VESSEL_U_STAMP_KEY,
} from './venti-form-sections.fields';
const VENTI_PRESSURE_VESSEL_KEYS = [
  VENTI_VESSEL_U_STAMP_KEY,
  'vesselServiceTypePrimary',
  'vesselInspector',
  'vesselSerialNumber',
  'vesselCapacityUswg',
  'vesselServiceTypeGrid',
  'vesselProvincialNo',
  'vesselCrnNo',
  'vesselMawp',
  'vesselYearBuilt',
  'vesselManufacturedBy',
  'vesselManwayLocation',
  'vesselHeadType',
  'vesselBaseType',
  'vesselHeadMaterial',
  'vesselShellMaterial',
  'vesselHeadThickness',
  'vesselShellThickness',
  'vesselDiameter',
  'vesselLength',
  'vesselSurfaceAreaSqFt',
  'vesselPrvCountAvailable',
  'vesselTotalScfmRequired',
  'vesselDataComments',
  'vesselNameplatePhoto',
] as const;

const VENTI_PRESSURE_VESSEL_BASE_QUESTION_ID = 99600;

const VENTI_PRV_BASE_QUESTION_ID = 99628;

const VENTI_EXTERNAL_BASE_QUESTION_ID = 99700;

const VENTI_BULK_BASE_QUESTION_ID = 99800;

export const VENTI_STATIC_FIELD_MAPPINGS: StaticFormFieldMappings = {
  siteContactName: 99101,
  bulkPlant: 99102,
  plantAddress: 99103,
  plantCoordinates: 99104,
  ownership: 99105,
  vesselSerialNo: 99106,
  ...Object.fromEntries(
    VENTI_PRESSURE_VESSEL_KEYS.map((controlKey, index) => [
      controlKey,
      VENTI_PRESSURE_VESSEL_BASE_QUESTION_ID + index,
    ]),
  ),
  ...Object.fromEntries(
    VENTI_PRV_INSTANCE_FIELD_KEYS.map((controlKey, index) => [
      controlKey,
      VENTI_PRV_BASE_QUESTION_ID + index,
    ]),
  ),
  ...Object.fromEntries(
    VENTI_EXTERNAL_VISUAL_CHECKLIST_KEYS.map((controlKey, index) => [
      controlKey,
      VENTI_EXTERNAL_BASE_QUESTION_ID + index,
    ]),
  ),
  externalVisualComments: 99731,
  externalVisualFooterPhotos: 99732,
  ...Object.fromEntries(
    VENTI_BULK_STORAGE_CHECKLIST_KEYS.map((controlKey, index) => [
      controlKey,
      VENTI_BULK_BASE_QUESTION_ID + index,
    ]),
  ),
  bulkStorageAfter10Comments: 99814,
  bulkStorageAfter14Comments: 99815,
  bulkStorageFooterComments: 99816,
  chiefInspector: 99517,
  signOffComments: 99518,
  actionTaken: 99519,
  inspectionNo: 99520,
  inspectionType: 99521,
  inspectionDate: 99522,
  inspectionOutcome: 99523,
  outcomeRemarks: 99524,
  technicianComments: 99525,
};
